import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import BookingButtonPresenterSidebar from "./BookingButtonPresenterSidebar"
import BookingButtonPresenterWorkspace from "./BookingButtonPresenterWorkspace"

class BookingButtonPresenterGeneral extends React.Component {

  constructor(props){
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  render(){

    var tabClasses = clsx({
			'active': this.props.active_tab == 'general',
			'tab-pane': true,
    })
    
    return (
      <div className={tabClasses} id="general">
       	<div className="booking-button-builder">
          <div className="row">
            <div className="col-md-4">
              <h5>{I18n.t('preferences')}</h5>
              <BookingButtonPresenterSidebar onChange={this.onChange}  {...this.props} />
            </div>
            <div className="col-md-8">
              <h5>{I18n.t('preview')}</h5>
              <BookingButtonPresenterWorkspace {...this.props} />
            </div>
          </div>
          <br />
        </div>
      </div>
    )
  }

  onChange(name, value) {
		var state = this.state;
		state[name] = value;
		this.setState(state);
  }
  
}

export default BookingButtonPresenterGeneral

